module.exports = __webpack_public_path__ + "static/media/21ECLAC1.28650a1a.jpg";